module.exports = __webpack_public_path__ + "images/icons/logos/partner-black-0217df1a.svg";